module.exports = __webpack_public_path__ + "img/Tommy86FrequencyModulations.a631d6d0.jpg";